<div class="table-responsive">
    <table mat-table [dataSource]="dataSource" matSort [multiTemplateDataRows]="tableDto.withDetailRow">
        
        <ng-container matColumnDef="#" >
            <th mat-header-cell *matHeaderCellDef > #</th>
            <td mat-cell *matCellDef="let i = index; let d = dataIndex">
                <ng-container *ngIf="tableDto.withDetailRow; else posNormal">
                    {{(paginator.pageIndex * paginator.pageSize) + (d + 1)}}
                </ng-container>
                <ng-template #posNormal>
                    {{(paginator.pageIndex * paginator.pageSize) + (i + 1)}}
                </ng-template>
            </td>
        </ng-container>
        <ng-container matColumnDef="select" *ngIf="tableDto.withSelectCheck" sticky>
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()" />
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="onCheckRowChange($event, row)" [checked]="selection.isSelected(row)"/>
            </td>
        </ng-container>
        <ng-container [matColumnDef]="column.key" [sticky]="column.withSticky" *ngFor="let column of tableDto.columns; let i=index" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{labelColumns[i]}} </th>
            <ng-container *ngIf="column.withNgClass">
                <td mat-cell *matCellDef="let row" [ngClass]="getClassToMap(getRowValue(column.key, row), column.lsCSS)">
                    {{getRowValue(column.key, row)}}
                </td>
            </ng-container>
            <ng-container *ngIf="tableDto.isListPatients && column.key === 'fullName'">
                <td mat-cell *matCellDef="let row" [class]="column.lsCSS">
                    <ng-container *ngTemplateOutlet="fusionIcon; context: getParamTemplate('patientFused', '', row, false)"></ng-container>
                </td>                
            </ng-container>
            <ng-container *ngIf="column.withTemplate; else normal">
                <td mat-cell *matCellDef="let row" [class]="column.lsCSS">
                    <ng-container *ngTemplateOutlet="column.template; context: getParamTemplate(column.templateContext, column.key, row, column.onlyValue)"></ng-container>
                </td>
            </ng-container>
            <ng-template #normal>
                <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="!column.isDate; else isDate">
                        {{getRowValue(column.key, row)}}
                    </ng-container>
                    <ng-template #isDate>
                        {{getRowValue(column.key, row, column.isDate, column.formatDate) }}
                    </ng-template>
                </td>
            </ng-template>
        </ng-container>

        <ng-container matColumnDef="action" *ngIf="tableDto.flagBtn && (tableDto.withDeleteAction || tableDto.withEditAction || tableDto.withButtonToggle)">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{columnAction}} </th>
            <td mat-cell *matCellDef="let row" class="text-center icon-in-table">
                <ng-container *ngIf="tableDto.withDeleteAction">
                    <button class="text-danger icon-btn" (click)="onDelete(row)" *ngIf="tableDto.flagBtn" type="button"><i class="far fa-trash"></i></button>
                </ng-container>
                <ng-container *ngIf="tableDto.withEditAction">
                    <button class="text-info icon-btn" (click)="onEdit(row)" *ngIf="tableDto.flagBtn" type="button"><i class="far fa-edit"></i></button>
                </ng-container>
                <ng-container *ngIf="tableDto.withButtonToggle">
                    <button mat-stroked-button color="primary" class="me-md-3" *ngIf="!row.isActive" (click)="onClick(row, true)" >{{tableDto.labelButtonToggle1}}</button>
                    <button mat-flat-button color="primary" class="me-md-3" *ngIf="row.isActive" (click)="onClick(row, false)">{{tableDto.labelButtonToggle2}}</button>
                </ng-container>
            </td>
        </ng-container>

        <ng-container *ngIf="tableDto.withDetailRow">
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let row" [attr.colspan]="displayColumns.length">
                <div class="example-element-detail" [@detailExpand]="expandedRow(getRowValue(tableDto.detailRow.columnKey, row))">
                    <ng-container *ngTemplateOutlet="tableDto.detailRow.template; context: getParamTemplate(tableDto.detailRow.templateContext, tableDto.detailRow.columnKey, row, tableDto.detailRow.onlyValue)"></ng-container>                    
                </div>
                </td>
            </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <ng-container *ngIf="tableDto && tableDto.withSelection; else noSelection">
            <tr mat-row (click)="onSelect(row)" *matRowDef="let row; columns: displayColumns;" [class.selected-row]="selectedRow === row"></tr>
        </ng-container>
        <ng-template #noSelection>
            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        </ng-template>
        <ng-container *ngIf="tableDto.withDetailRow">            
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </ng-container>

        <tr class="mat-row pl-2 pt-2" *matNoDataRow>
            <td class="mat-cell p-3 text-center text-secondary" [colSpan]="colN">{{ msgNoData }}</td>
        </tr>

    </table>
</div>
<mat-paginator [pageSizeOptions]="[10, 15, 20]" showFirstLastButtons></mat-paginator>
<ng-template #fusionIcon let-patientFused="patientFused">
    <ng-container *ngIf="isFusedPatient(patientFused)">
        <i class="far fa-merge me-1"></i>        
    </ng-container>
     {{ printName(patientFused) }}
</ng-template>
